import React, { useEffect, useState } from 'react';
import { TextField, Button, Autocomplete } from '@mui/material';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { flattenArray, uniqueArray } from 'utils';
import CardBasic from 'screens/shared/card-basic';
import { v4 } from 'ip-regex';
import { VALIDATION_PRIVATE_IPS_REGEX } from 'constant';

export default ({
  label = 'IPs',
  helpText = '',
  value,
  onChange,
  error,
  style = {},
  privateOnly = false,
}) => {
  const [ip, setIp] = useState('');
  const [innerError, setInnerError] = useState('');
  let { [ACTIONS_TYPES.IP.GET_ALL]: ips = [] } = useSelector((e) => e);
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter } = useSelector((e) => e);
  const { properties: dcProps = {} } = datacenter;

  ips = ips.filter(({ properties: { location } }) => location === dcProps.location);
  ips = ips.map(({ properties: { ips: ipsList = [] } = {} }) => ipsList);
  ips = flattenArray(ips);
  ips = ips.filter((e) => !value.includes(e));

  const changeHandler = (e, newValue) => (newValue
    ? setIp(newValue)
    : setIp(e.target.value || ''));

  useEffect(() => {
    actions.ip.getAll();
  }, []);

  const addHandler = () => {
    if (!ip) {
      return setInnerError('This field is required!');
    }

    if (!privateOnly && !v4({ exact: true }).test(ip)) {
      return setInnerError('The value is not a valid IP');
    }

    if (privateOnly && !VALIDATION_PRIVATE_IPS_REGEX.test(ip)) {
      return setInnerError('The value is not a valid Private IP');
    }

    value.push(ip);
    setInnerError('');
    setIp('');
    return onChange(uniqueArray(value));
  };

  const deleteHandler = (i) => {
    value.splice(i, 1);
    onChange(value);
  };

  return (
    <div>
      <div className="ips-selector" style={error ? { border: '1px solid #f44336' } : {}}>
        <span className="font-16 color-base p-t-10 p-b-12">{label}</span>
        {helpText && <span className="font-14 color-dark m-t-4- p-b-12">{helpText}</span>}
        <div className="flex flex-align-end flex-direction-column">
          {privateOnly && (
            <TextField
              className="w-100p m-t-4 m-b-8"
              style={style}
              label="Private IP"
              variant="outlined"
              fullWidth
              value={ip}
              onChange={changeHandler}
              error={!!innerError}
              helperText={innerError}
            />
          )}

          {!privateOnly && (
            <Autocomplete
              options={ips.filter((e) => e.includes(ip))}
              getOptionLabel={(option) => option}
              className="w-100p m-t-4 m-b-8"
              style={style}
              value={ip || null}
              onChange={changeHandler}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="IP"
                  variant="outlined"
                  fullWidth
                  value={ip}
                  onChange={changeHandler}
                  error={!!innerError}
                  helperText={innerError}
                />
              )}
            />
          )}
          <Button className="m-l-10" variant="contained" size="small" color="primary" onClick={addHandler}>Add IP</Button>
        </div>

        {!!value.length && (
          <div className="m-t-10 m-b-10">
            {value.map((e, i) => (
              <CardBasic
                key={e}
                title={e}
                icon="network-wired"
                actionButtons={{
                  delete: () => deleteHandler(i),
                }}
              />
            ))}
          </div>
        )}
      </div>
      { error && (
        <span className="relative top-8- left-14 font-12 color-danger">{error}</span>
      )}
    </div>
  );
};
